var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0H18.75C19.4414 0 20 0.558594 20 1.25V2.5C20 3.19141 19.4414 3.75 18.75 3.75H1.25C0.558594 3.75 0 3.19141 0 2.5V1.25C0 0.558594 0.558594 0 1.25 0ZM1.25 5H18.75V15C18.75 16.3789 17.6289 17.5 16.25 17.5H3.75C2.37109 17.5 1.25 16.3789 1.25 15V5ZM6.25 8.125C6.25 8.46875 6.53125 8.75 6.875 8.75H13.125C13.4688 8.75 13.75 8.46875 13.75 8.125C13.75 7.78125 13.4688 7.5 13.125 7.5H6.875C6.53125 7.5 6.25 7.78125 6.25 8.125Z",
    fill: "#9B9FA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.741b71b1a932b6b6643277cf091020e3.svg";
export { ForwardRef as ReactComponent };